<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-pencil</v-icon>
            {{ edit ? "Editar" : "Cadastrar" }} Avaliação
          </div>
        </v-toolbar>

        <div class="container dialog">
          <v-form ref="form" v-if="visible">
            <v-row class="d-flex justify-center mt-7">
              <v-col cols="4">
                <v-select
                    v-model="content.tipoAvaliacao"
                    :items="content.listTipoAvaliacao"
                    item-text="descricao"
                    item-value="tipoAvaliacaoId"
                    return-object
                    :rules="[(v) => v !== null && v !== undefined || 'Campo obrigatório']"
                    label="Tipo de Avaliação*"
                    outlined
                    dense
                />
              </v-col>
              <v-col cols="8">
                <v-text-field
                    label="Nome da Avaliação*"
                    v-model="content.nome"
                    outlined
                    dense
                    maxlength="40"
                    counter="40"
                    :rules="[
                      (v) => !!v || 'Campo obrigatório',
                      (v) => (v && v.length <= 40) || 'Máximo de 40 caracteres'
                    ]"
                />
              </v-col>
            </v-row>

            <v-row class="d-flex justify-center mt-7">
              <v-col cols="12">
                <v-text-field
                    label="Descrição da Avaliação"
                    v-model="content.descricao"
                    outlined
                    dense
                    maxlength="250"
                    counter="250"
                    :rules="[
                      (v) => !v || v.length <= 250 || 'Máximo de 250 caracteres'
                    ]"
                />
              </v-col>
            </v-row>

            <v-form ref="formPergunta" v-model="validFormPergunta">
              <v-row class="d-flex justify-center align-end mt-7">
                <v-col cols="4">
                  <v-text-field
                      label="Pergunta*"
                      v-model="pergunta.pergunta"
                      outlined
                      dense
                      maxlength="250"
                      counter="250"
                      :rules="[
                        (v) => !!v || 'Campo obrigatório',
                        (v) => (v && v.length <= 250) || 'Máximo de 250 caracteres'
                      ]"
                  />
                </v-col>
                <v-col cols="3">
                  <v-select
                      v-model="pergunta.tipoResposta"
                      :items="content.listTiposResposta"
                      item-text="descricao"
                      item-value="tipoRespostaId"
                      return-object
                      :rules="[(v) => v !== null && v !== undefined || 'Campo obrigatório']"
                      label="Tipo de Resposta*"
                      outlined
                      dense
                  />
                </v-col>
                <v-col cols="4" class="pr-0">
                  <v-select
                      v-model="pergunta.obrigatoriedade"
                      :items="content.listObrigatoriedade"
                      item-text="descricao"
                      item-value="obrigatoriedade"
                      return-object
                      :rules="[(v) => v !== null && v !== undefined || 'Campo obrigatório']"
                      label="Obrigatoriedade*"
                      outlined
                      dense
                  />

                </v-col>
                <v-col cols="1" class="d-flex align-center mb-8 pa-0">
                  <v-btn
                      class="pa-0 mb-3 ml-4"
                      small
                      plain
                      :ripple="false"
                      color="primary darken-1"
                      @click="adicionarPergunta"
                  >
                    <v-icon>mdi-plus-circle-outline</v-icon>
                  </v-btn>
                </v-col>
              </v-row>

            </v-form>

            <v-data-table
                class="mt-5"
                :headers="headers"
                :items="content.perguntas"
                :items-per-page="5"
                :key="tableKey"
                :footer-props="$footerProps"
            >
              <template v-slot:[`item.pergunta`]="{ item }">
                {{ item.pergunta }}
              </template>
              <template v-slot:[`item.tipoResposta`]="{ item }">
                {{ item.tipoResposta.descricao }}
              </template>

              <template v-slot:[`item.obrigatoriedade`]="{ item }">
                {{ item.obrigatoriedade.descricao }}
              </template>

              <template v-slot:[`item.acoes`]="{ item, index }">
                <div :key="index">
                  <sigfoco-tooltip
                      :text="'Editar Pergunta'"
                      :icon="'mdi-pencil'"
                      :small="true"
                      @click="editarPergunta(item, index)"
                  />
                  <sigfoco-tooltip
                      :text="'Excluir'"
                      :icon="'mdi-delete'"
                      :small="true"
                      @click="excluirPergunta(item)"
                  />
                </div>
              </template>
            </v-data-table>
          </v-form>
        </div>

        <sigfoco-buttons
            @click="salvar"
            @cancel="limparFormulario()"
            :actionText="'Salvar'"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { AvaliacaoFormacao } from '~/commons/classes/avaliacao-formacao';
import PeriodoAvaliacaoService from '~/services/manter-avaliacao-formacao';
import PermissaoService from '~/services/permissao.service';

export default {
  props: new DialogProps(AvaliacaoFormacao),
  mixins: [PeriodoAvaliacaoService, PermissaoService],
  data() {
    return {
      validFormPergunta: true,
      validFormContent: true,
      tableKey: 0,
      headers: [
        { text: 'Pergunta', align: 'center', value: 'pergunta' },
        { text: 'Tipo de Resposta', align: 'center', value: 'tipoResposta' },
        { text: 'Obrigatoriedade', align: 'center', value: 'obrigatoriedade' },
        { text: 'Ações', align: 'center', value: 'acoes', sortable: false },
      ],
      pergunta: {
        id: null,
        pergunta: null,
        tipoResposta: null,
        obrigatoriedade: null,
      },
    };
  },
  methods: {
    adicionarPergunta() {
      const form = this.$refs.formPergunta;
      if (form && form.validate()) {
        if (this.editandoIndex != undefined && this.editandoIndex !== null) {
          this.$set(this.content.perguntas, this.editandoIndex, { ...this.pergunta });
          this.editandoIndex = null;
        } else {
          this.content.perguntas.push({ ...this.pergunta });
        }
        this.pergunta = { id: null, pergunta: null, tipoResposta: null, obrigatoriedade: null };
        this.tableKey++;
        form.resetValidation();
      } else {
        this.$notifyError('Preencha todos os campos obrigatórios!');
      }
    },
    salvar() {
      const form = this.$refs.form;
      const isValid = form && form.validate();
      const perguntasValidas = this.content.perguntas.length > 0;

      if (!isValid || !perguntasValidas) {
        this.$notifyError('Preencha todos os campos obrigatórios!');
        return;
      }

      this.$swal({
        text: 'Deseja confirmar essa operação?',
        type: "warning",
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar'
      }).then(() => {
        const payloadEditar = new AvaliacaoFormacao(this.content).formatParaEditar();
        const payloadCadastrar = new AvaliacaoFormacao(this.content).formatParaCadastrar();
        const operacao = this.edit
            ? this.$editarAvaliacaoFormacao(payloadEditar, payloadEditar.id)
            : this.$cadastrarAvaliacaoFormacao(payloadCadastrar);


        operacao
            .then(({ data }) => {
              this.$notifySuccess(data.mensagem);
              this.limparFormulario();
              this.$emit('onSave');
            })
            .catch((response) => {
              this.$notifyError(response.response.data.mensagem);
            });
      });
    },
    editarPergunta(item, index) {
      this.pergunta = { ...item };
      this.editandoIndex = index;
    },
    excluirPergunta(item) {
      this.content.perguntas = this.content.perguntas.filter(p => p !== item);
      this.tableKey++;
    },
    limparFormulario() {
      this.pergunta = { id: null, pergunta: null, tipoResposta: null, obrigatoriedade: null };
      this.editandoIndex = null;
      this.$emit('onClose');

    }
  }
};
</script>

<style scoped>
.dialog {
  padding: 24px;
}
</style>